import { Outlet } from 'react-router';

import Box from '@/design_system/Box';
import Logo from '@/design_system/Logo';
import { createBEMClasses } from '@/utils/classname';

const { block, element } = createBEMClasses('auth-layout');

import config from '@/config';
import { ErrorBoundary } from '@/services/sentry';

import './Auth.css';

const AuthLayout = () => {
  let alias = config.alias;

  if (window.location.hostname.endsWith('.prolong.io')) {
    const firstPart = window.location.hostname.split('.')[0];

    if (!['dev', 'staging', 'app'].includes(firstPart)) {
      alias = firstPart;
    }
  }

  return (
    <section className={block()}>
      <div className={element('container')}>
        {alias ? (
          <img
            className={element('brand-logo')}
            src={`${config.apiUrl}/organizations/${alias}/logo?alias=1`}
            alt=""
          />
        ) : (
          <Logo />
        )}
        <Box padding="32px" gap="2rem" className="bg-neutral-0">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </Box>
      </div>
    </section>
  );
};

export default AuthLayout;
